import React from "react";
import { Select } from "@pd/pd-ui-kit";
import { Control, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

import FormField from "~/pages/BaseStaff/EmployeeProfileEditor/EmployeeProfileForm/sections/FormField";
import { IEmployeeProfileForm } from "~/pages/BaseStaff/EmployeeProfileEditor/EmployeeProfileForm/model/types";

import s from "~/pages/BaseStaff/EmployeeProfileEditor/EmployeeProfileForm/EmployeeProfileForm.less";

interface IEducationSelectFieldProps {
  name:
    | `positions.${number}.educationTraining`
    | `positions.${number}.educationCertificate`;
  control: Control<IEmployeeProfileForm>;
  label: string;
  options: { value: string; label: string }[];
  onOpenLink: () => void;
}

const EducationSelectField = ({
  name,
  control,
  label,
  options,
  onOpenLink,
}: IEducationSelectFieldProps) => {
  const { t } = useTranslation();

  return (
    <FormField label={label}>
      <Controller
        name={name}
        control={control}
        render={({ value }) => (
          <div
            className={value ? s.educationLinkField : undefined}
            onClick={value ? onOpenLink : undefined}
          >
            <Select
              value={value || undefined}
              options={options}
              disabled
              placeholder={t("employee.noPosition")}
              labelRender={(selected) =>
                value ? (
                  <span className={s.educationLink}>{selected.label}</span>
                ) : (
                  selected.label
                )
              }
            />
          </div>
        )}
      />
    </FormField>
  );
};

export default EducationSelectField;
